import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Services from "@/components/Services";
import Atelier from "@/components/Atelier";
import Journey from "@/components/Journey";
import Interiors from "@/components/Interiors";
import Testimonials from "@/components/Testimonials";
import QuoteSimulator from "@/components/QuoteSimulator";
import Booking from "@/components/Booking";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function Home() {
    return (
        <div data-testid="home-page" className="min-h-screen">
            <Navbar />
            <main>
                <Hero />
                <About />
                <Services />
                <Atelier />
                <Journey />
                <Interiors />
                <Testimonials />
                <QuoteSimulator />
                <Booking />
                <Contact />
            </main>
            <Footer />
        </div>
    );
}
